module.exports = __webpack_public_path__ + "static/media/icon_kijkwijzer_drugs.3dd5fa70.svg";